import OlbRange from './range.vue';
export default OlbRange;
